module.exports = __webpack_public_path__ + "img/2_95.125f0fac.png";